// For multi--sku items, get displayInfo from the selected sku
export const getDisplayInfo = ({ displayInfo, skus, selectedSkuId, isMultiSku }) => {
    if (isMultiSku && skus) {
        const selectedSku = skus.find(sku => sku.serviceId === selectedSkuId);
        if (selectedSku) {
            return selectedSku.displayInfo;
        }
    }
    return displayInfo;
};
